import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LoaderButton from '../loader-button/LoaderButton';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  CardTitle,
  Table,
  Input,
  Label,
  Alert
} from 'reactstrap';

const InputUserModal = ({
  isReadOnly,
  userRbacRoles,
  modalOpen,
  setModalOpen,
  loader,
  roles,
  selectedUser,
  updateUser
}) => {
  // const [integrationMode, setIntegrationMode] = useState(integrationOptions[0]);
  const [rolePerms, setRolePerms] = useState({});

  useEffect(() => {
    const userRoles = {};
    userRbacRoles.forEach(element => {
      const roleId = element.rbacRoleId;
      userRoles[roleId] = true;
    });
    setRolePerms(userRoles);
  }, [roles, selectedUser, userRbacRoles]);
  // Handle checkboxes for role permissions
  const handleSetRole = (roleId, value) => {
    if (!rolePerms[roleId]) rolePerms[roleId] = {};
    rolePerms[roleId] = value;
    setRolePerms({ ...rolePerms });
  };

  const handleSaveUser = async () => {
    const userRoles = [];
    for (const roleId in rolePerms) {
      if (Object.hasOwnProperty.call(rolePerms, roleId) && rolePerms[roleId]) {
        userRoles.push({
          rbacRoleId: roleId,
          rbacUserId: selectedUser.Username
        });
      }
    }
    const payload = {
      userRoles
    };

    // Updating a role
    updateUser(payload);
  };

  // Load permissions
  // iterate permissions and set rolePermsView, roleAllView and manage...
  const email = selectedUser.Attributes.find(item => item.Name === 'email').Value;
  return (
    <Fragment>
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
        <ModalHeader>Edit user: {email}</ModalHeader>
        <ModalBody>
          {isReadOnly && (
            <Alert color="info">
              Note: Your user only has read-only access. You will not be able to save any updates.
            </Alert>
          )}

          <CardTitle data-testid={'kw-exclude-title'}>Roles</CardTitle>
          <Table bordered striped style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Name</th>
                <th>Assigned</th>
              </tr>
            </thead>
            <tbody>
              {roles?.length ? (
                roles.map(role => {
                  return (
                    <tr key={role.id} id={role.id} className="font-weight-bold" data-testid={'role-row'}>
                      <td>
                        <div className="py-2">{role.name}</div>
                      </td>
                      <td>
                        {' '}
                        <FormGroup check>
                          <Input
                            id={`role-manage-${role.id}`}
                            type="checkbox"
                            checked={!!rolePerms[role.id]}
                            onChange={() => {
                              if (!rolePerms[role.id]) handleSetRole(role.id, true);
                              else handleSetRole(role.id, !rolePerms[role.id]);
                            }}
                            data-testid={'role-manage-checkbox'}
                          />
                          <Label for={`role-manage-${role.id}`} check data-testid={'role-all-manage-label'}>
                            {' '}
                            Assigned
                          </Label>
                        </FormGroup>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr className="font-weight-bold">
                  <td>No roles found.</td>
                  <td />
                  <td />
                </tr>
              )}

              <tr />
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <>
            <Button color="falcon-danger" onClick={() => setModalOpen(!modalOpen)} data-testid={'cancel-btn'}>
              Cancel
            </Button>
            <LoaderButton
              color="falcon-primary"
              disabled={isReadOnly}
              onClick={handleSaveUser}
              isLoading={loader}
              name="save-and-add"
              size="sm"
            >
              Save user
            </LoaderButton>
          </>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

InputUserModal.propTypes = {
  isReadOnly: PropTypes.bool,
  isLoading: PropTypes.bool,
  handleSave: PropTypes.func,
  userRbacRoles: PropTypes.array,
  roles: PropTypes.array,
  setModalOpen: PropTypes.func,
  modalOpen: PropTypes.bool,
  updateUser: PropTypes.func,
  loader: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  selectedUser: PropTypes.object,
  setUserName: PropTypes.func,
  setIsSubmitted: PropTypes.func,
  setSelectedUser: PropTypes.func
};

export default InputUserModal;
